module.exports = __webpack_public_path__ + "media/Video.2e1e2605.mp4";